import { DeviceDetectProvider } from 'components/DeviceDetect'
import React from 'react'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import { renderRoutes, routes } from 'route'
import { AuthContextProvider } from 'store/AuthContext'
import { CacheContextProvider } from 'store/CacheProvider'
import { CartContextProvider } from 'store/CartProvider'
import { ConfigContextProvider } from 'store/ConfigProvider'
import { FilterContextProvider } from 'store/FilterProvider'
import { InnerPageContextProvider } from 'store/InnerPageProvider'
import { OrdersContextProvider } from 'store/OrdersProvider'
import { SingleProductContextProvider } from 'store/SingleProductProvider'
import { SelectedColorProvider } from 'store/SelectedColorProvider'
import './App.css'
import BackToTop from './components/BackToTop/BackToTop'
import { AffilateContextProvider } from 'store/AffilateContext'
import { getUrlParam } from 'consts'
import { WishlistContextProvider } from 'store/WishlistContext'
import { getTokenFromURL } from './helpers/token'
import api from 'services/api'


function setClickIdsIntoStorage() {
  if (getUrlParam('gclid')) {
    localStorage.setItem('gclid', getUrlParam('gclid'))
  }
  if (getUrlParam('fbclid')) {
    localStorage.setItem('fbclid', getUrlParam('fbclid'))
  }
  if (getUrlParam('ctclid')) {
    localStorage.setItem('ctclid', getUrlParam('ctclid'))
  }
}

setClickIdsIntoStorage()

function App(props) {
  let cache = props.cache

  if (!cache && typeof window != 'undefined') {
    cache = window.cache
  }

  const tokenFromURL = getTokenFromURL()

  if (tokenFromURL) {
    api.setToken(tokenFromURL)

    const url = new URL(window.location)
    url.searchParams.delete('token')
    window.history.replaceState({}, document.title, url.toString())
  }

  return (
    <DeviceDetectProvider>
      <CacheContextProvider cache={cache}>
        <AuthContextProvider>
          <AffilateContextProvider>
            <ConfigContextProvider>
              <OrdersContextProvider>
                <SingleProductContextProvider>
                  <SelectedColorProvider>
                    <CartContextProvider>
                      <WishlistContextProvider>
                        <FilterContextProvider>
                          <InnerPageContextProvider>
                            {renderRoutes(routes)}
                            <BackToTop />
                          </InnerPageContextProvider>
                        </FilterContextProvider>
                      </WishlistContextProvider>
                    </CartContextProvider>
                  </SelectedColorProvider>
                </SingleProductContextProvider>
              </OrdersContextProvider>
            </ConfigContextProvider>
          </AffilateContextProvider>
        </AuthContextProvider>
      </CacheContextProvider>
    </DeviceDetectProvider>
  )
}

export default App
